module.exports = __webpack_public_path__ + "static/media/background.6002a726.jpg";